/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Create_ButtonInputs */



/**
* | output |
* | --- |
* | "Create Group" |
*
* @param {Translation_Merge_Create_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_create_button = /** @type {((inputs?: Translation_Merge_Create_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Create_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Creer le groupe")
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppe erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea gruppo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать группу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear grupo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建组")
	if (locale === "ja") return /** @type {LocalizedString} */ ("グループを作成")
	if (locale === "hi") return /** @type {LocalizedString} */ ("समूह बनाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar grupo")
	return /** @type {LocalizedString} */ ("Create Group")
});